export default "assets/images/logo-circle-4f30307d.png";